import CardLink from 'features/shared/components/buttons/CardLink';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { loadPortalConfig } from 'features/shared/helpers/modules';
import OidcRolesChecker from 'infrastructure/oidc/OidcRolesChecker';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const portalConfig = loadPortalConfig();

const AdministrationSection = () => {
  // translations
  const tLabels = useTranslation("admin\\administration").t;

  // router
  const history = useHistory();

  // render
  return (
    <div className="row no-gutters mx-n2">
      <div className="col-sm-6 col-lg-4 col-xl-3 px-2">
        <CardLink 
          title={tLabels("administrationSection.setUser")}
          icon="user"
          iconAsAvatar={false}
          onClick={() => history.push("user-select")}
        />
      </div>
      <OidcRolesChecker enabledRoles="admin">
        <div className="col-sm-6 col-lg-4 col-xl-3 px-2">
          <CardLink 
            title={tLabels("administrationSection.managePortalAccounts")}
            icon="users-cog"
            iconAsAvatar={false}
            onClick={() => history.push("customers")}
          />
        </div>
      </OidcRolesChecker>
      <OidcRolesChecker enabledRoles="admin">
        <div className="col-sm-6 col-lg-4 col-xl-3 px-2">
          <CardLink 
            title={tLabels("administrationSection.generateAccounts")}
            icon="users"
            iconAsAvatar={false}
            onClick={() => history.push("generate-accounts")}
          />
        </div>
      </OidcRolesChecker>
      <RenderWrapper isVisible={() => portalConfig.enableContracting}>
        <div className="col-sm-6 col-lg-4 col-xl-3 px-2">
          <CardLink 
            title={tLabels("administrationSection.overviewContractings")}
            icon="file-signature"
            iconAsAvatar={false}
            onClick={() => history.push("admin/contractings")}
          />
        </div>
      </RenderWrapper>
    </div>
  )
}

export default AdministrationSection;
